import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { NavMarker } from 'react-rhumb';
import ProductInfoContainer from '../../common/ProductInfoContainer';
import ProductPageTitle, { ProductPageHeader } from '../../product-pages/ProductPageTitle';
import ProductPageSubtitle from '../../product-pages/ProductPageSubtitle';
import MobileDropdownNav from '../MobileDropdownNav';
import CompareStatusFooter from '../../compare/CompareStatusFooter';

const MobileWrapperNoTabs = ({
  navMarkerName,
  navItem,
  children
}) => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      "data-selenium-id": "page-success",
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: navMarkerName
      }), /*#__PURE__*/_jsx(MobileDropdownNav, {
        selectedNavItem: navItem
      }), /*#__PURE__*/_jsxs(ProductInfoContainer, {
        children: [/*#__PURE__*/_jsxs(ProductPageHeader, {
          children: [/*#__PURE__*/_jsx(ProductPageTitle, {
            nonProductIdentifier: navItem
          }), /*#__PURE__*/_jsx(ProductPageSubtitle, {
            nonProductIdentifier: navItem
          })]
        }), children]
      }), navMarkerName === 'FREE_TOOLS_PAGE' && /*#__PURE__*/_jsx(CompareStatusFooter, {})]
    })
  });
};

export default MobileWrapperNoTabs;